/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const ChannelR = t.interface({
  channel_code: t.string,

  enabled: t.boolean,

  primitive_version: t.Integer
});

// optional attributes
const ChannelO = t.partial({
  broker_description: t.string
});

export const Channel = t.intersection([ChannelR, ChannelO], "Channel");

export type Channel = t.TypeOf<typeof Channel>;
